document.addEventListener('DOMContentLoaded', function () {
  // Lightweight section reveal: progressive enhancement only.
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sections = Array.from(document.querySelectorAll('#MainContent > .shopify-section'));
  var pageSections = Array.from(document.querySelectorAll('.paw-page-hero, .paw-editorial, .paw-values, .paw-page-cta, .paw-review-intro, .paw-trust-band, .paw-contact-grid, .paw-original-content'));
  var revealTargets = pageSections.length > 1 ? pageSections : sections;
  if (!reduceMotion && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('paw-reveal-ready');
    revealTargets.forEach(function (section, index) {
      section.classList.add('paw-reveal');
      // Keep the first section visible immediately; reveal the rest as they enter view.
      if (index === 0) section.classList.add('is-visible');
    });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealTargets.slice(1).forEach(function (section) { observer.observe(section); });
  }

  var popup = document.querySelector('[data-paw-offer-popup]');
  if (!popup) return;
  var key = 'ff_signup_dismissed_v1', subscribed = 'ff_signup_complete_v1';
  var read = function(k) { try { return localStorage.getItem(k); } catch(e) { return null; } };
  var write = function(k,v) { try { localStorage.setItem(k,v); } catch(e) {} };
  var previous;
  function close() {
    popup.classList.remove('is-visible'); popup.setAttribute('aria-hidden','true'); popup.inert = true;
    document.body.classList.remove('paw-popup-open'); write(key,String(Date.now()));
    if(previous && previous.isConnected) previous.focus({preventScroll:true});
  }
  function show() {
    if(document.body.classList.contains('paw-menu-open')) { window.setTimeout(show,1000); return; }
    previous = document.activeElement; popup.inert = false; popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden','false'); document.body.classList.add('paw-popup-open');
    (popup.querySelector('[data-signup-result]') || popup.querySelector('#FinestEmail') || popup.querySelector('.paw-offer-close')).focus({preventScroll:true});
  }
  popup.querySelectorAll('[data-paw-popup-close]').forEach(function(b){b.addEventListener('click',close);});
  document.addEventListener('keydown',function(e){
    if(!popup.classList.contains('is-visible')) return;
    if(e.key === 'Escape') close();
    if(e.key === 'Tab') {
      var items = Array.from(popup.querySelectorAll('a,button,input')).filter(function(x){return x.type !== 'hidden' && x.tabIndex >= 0 && !x.disabled && x.getClientRects().length;});
      var first=items[0], last=items[items.length-1];
      if(e.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) {e.preventDefault();last.focus();}
      else if(!e.shiftKey && (document.activeElement === last || !items.includes(document.activeElement))) {e.preventDefault();first.focus();}
    }
  });
  var result=popup.querySelector('[data-signup-result]');
  if(result) {if(result.dataset.signupResult === 'success') write(subscribed,'1'); show();}
  else if(!read(subscribed) && Date.now()-Number(read(key)||0) > 7*86400000) window.setTimeout(show,10000);

});

// V6 mobile navigation
(function () {
  var toggle = document.querySelector('[data-mobile-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (!toggle || !menu) return;
  var closeBtn = menu.querySelector('[data-mobile-menu-close]');
  function openMenu(){menu.classList.add('is-open');menu.setAttribute('aria-hidden','false');toggle.setAttribute('aria-expanded','true');document.body.classList.add('paw-menu-open');if(closeBtn) closeBtn.focus({preventScroll:true});}
  function closeMenu(){menu.classList.remove('is-open');menu.setAttribute('aria-hidden','true');toggle.setAttribute('aria-expanded','false');document.body.classList.remove('paw-menu-open');}
  toggle.addEventListener('click', function(){ menu.classList.contains('is-open') ? closeMenu() : openMenu(); });
  if(closeBtn) closeBtn.addEventListener('click', closeMenu);
  menu.addEventListener('click', function(e){ if(e.target === menu) closeMenu(); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu(); });
})();
